import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      gap: '8px',
    },
    signContainer: {
    // width: '100%',
      aspectRatio: '4/2',
      backgroundColor: colors.bg.subtle,
      border: `1px solid ${colors.disabled.muted}`,
      borderRadius: 8,
      height: 216,
      width: 430,
      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
    signWrapper: {
      height: 216,
      width: 430,
      '@media (max-width: 600px)': {
        width: '100%',
        height: 'auto',
      },
    },
    button: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '12px',
      gap: '10px',
      borderRadius: '6px',
      border: 'none',
      fontSize: '14px',
      marginBottom: '10px',
      width: '100%',
      ':hover': {
        cursor: 'pointer',
      },
    },
    btnWrapper: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      gap: '8px',
    },
    cmodal: {
      '& .mantine-Paper-root': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 !important',
        backdropFilter: 'blur(34px)',
        [`@media (max-width: ${theme.breakpoints.xs})`]: {
          maxHeight: '100%',
          height: '100%',
        },
      },
    },
    btnWrapperLeft: {
      width: '60%',
      gap: '8px',
    },
    footer: {
      padding: '20px 0 !important',
      borderTop: 'none !important',
    },
  };
});

export default useStyles;
